import { AddBoardElementTo } from '@/core/store/user-content/user-content-types';

import { ContentTypeEnum } from '../Common/bento-constants';

export const getNextPositions = (focusView: string, position: any) => {
  const gridDesktop = focusView == 'desktop' ? position?.desktop || [] : position?.mobile || [];
  let nextX = 0;
  let nextY = 0;
  const MaxY = 0;
  let numberOfItems = [0, 0, 0, 0];

  if (gridDesktop.length > 0) {
    nextY = 1000;
    gridDesktop.forEach((item: any) => {
      numberOfItems[item.x] =
        numberOfItems[item.x] > item.y + item.h ? numberOfItems[item.x] : item.y + item.h;
      if (item.w == 2) {
        numberOfItems[item.x + 1] =
          numberOfItems[item.x + 1] > item.y + item.h ? numberOfItems[item.x] : item.y + item.h;
      }
      if (item.w >= 4) {
        numberOfItems = numberOfItems.map((val, index) => {
          if (index == 0) {
            return val;
          }
          return item.y + item.h;
        });
      }
    });

    for (let i = 0; i < numberOfItems.length; i++) {
      if (numberOfItems[i] < nextY) {
        nextY = numberOfItems[i];
        nextX = i;
      }
    }
  }

  return [nextX, nextY];
};

export const getLastY = (focusView: string, position: any) => {
  const targetPosition = focusView == 'desktop' ? position?.desktop || [] : position?.mobile || [];
  let nextY = 0;
  const count = targetPosition.length;

  if (targetPosition) {
    const sorted = [...targetPosition];
    sorted.sort((x: any, y: any) => {
      const mpXY1 = x.y + x.h;
      const mpY2 = y.y + y.h;
      return mpXY1 - mpY2;
    });
    const element = sorted[count - 1];
    if (element) {
      nextY = element.y + element.h;
    }
  }

  return nextY;
};

export const generateSize = (element: any) => {
  const rand = Math.random() > 0.5 ? 1 : 2;
  if (element.size) {
    const { width, height } = element.size;
    if (width > height * 1.3) {
      return {
        width: 2,
        height: 4,
      };
    } else if (width > height * 1.5) {
      return {
        width: 3,
        height: 6,
      };
    } else if (height > width * 1.3) {
      return {
        width: 1,
        height: 6,
      };
    } else if (height > width * 1.5) {
      return {
        width: 1,
        height: 8,
      };
    }
  }
  return {
    width: 1 * rand,
    height: 4 * rand,
  };
};

export const createAddElementPayload = (
  element: {
    _id?: string;
    contentType: ContentTypeEnum;
    elementId?: { elementType: string; url: string };
    contentData?: { text?: string; url?: string };
  },
  x: number,
  y: number,
  w: number,
  h: number,
  onlyContents?: boolean,
) => {
  const payload: AddBoardElementTo = {
    newElement: {
      ui: {
        desktop: {
          x: x,
          y: y,
          w: w,
          h: h,
        },
        mobile: {
          x: x,
          y: y,
          w: w,
          h: h,
        },
      },
    },
  };

  if (element?.contentType) {
    payload.newElement.contentType = element.contentType;
  }

  if (
    (element._id &&
      element.contentType != ContentTypeEnum.ASSET &&
      element.contentType != ContentTypeEnum.PORTAL) ||
    onlyContents
  ) {
    payload.newElement.contentId = element._id;
  }

  if (element.elementId) {
    payload.newElement.elementType = element.elementId.elementType;
    payload.newElement.url = element.elementId.url;
  }

  //check
  if (element.contentData && Object.keys(element.contentData).length > 0) {
    payload.newElement.contentData = element.contentData;
  }

  return payload;
};

export const createAddElementPayloadNext = (action: any, position: any, w: number, h: number) => {
  const [x, y] = getNextPositions('desktop', position);
  return createAddElementPayload(action, x, y, w, h);
};
